import { SignIn } from './SignIn';
import { Filter } from './Filter';
import { SignUp } from './SignUp';
import { MyWallet } from './MyWallet';
import { Checkout } from './Checkout';
import { MyCoupons } from './MyCoupons';
import { MyWishlist } from './MyWishlist';
import { Onboarding } from './Onboarding';
import { NewPassword } from './NewPassword';
import { ProfileEdit } from './ProfileEdit';
import { AddANewCard } from './AddANewCard';
import { LeaveAReview } from './LeaveAReview';
import { CategoryList } from './CategoryList';
import { CategoryGrid } from './CategoryGrid';
import { Dashboard } from './Dashboard';
import { CourseDetails } from './CourseDetails';
import { PaymentFailed } from './PaymentFailed';
import { PrivacyPolicy } from './PrivacyPolicy';
import { PaymentSuccess } from './PaymentSuccess';
import { ForgotPassword } from './ForgotPassword';
import { HelpAndSupport } from './HelpAndSupport';
import { CourseCompleted } from './CourseCompleted';
import { ConfirmationCode } from './ConfirmationCode';
import { ChoosePaymentMethod } from './ChoosePaymentMethod';
import { SignUpAccountCreated } from './SignUpAccountCreated';
import { VerifyYourPhoneNumber } from './VerifyYourPhoneNumber';
import { ForgotPasswordSentEmail } from './ForgotPasswordSentEmail';
import { CourseCompletedCertificate } from './CourseCompletedCertificate';

// Tabs
import { Home } from './tabs/Home';
import { Search } from './tabs/Search';
import { Profile } from './tabs/Profile';
import { MyCourses } from './tabs/MyCourses';
import { AminitiesList } from './AminitiesList';
import { Onboarding1 } from './Onbording1';
import { Onboarding2 } from './Onbording2';
import { Onboarding3 } from './Onbording3';
import { Onboarding4 } from './Onbording4';
import { Onboarding5 } from './Onbording5';
import { Onboarding6 } from './Onbording6';
import { Onboarding0 } from './Onbording0';
import { Onboarding7 } from './Onbording7';
import NotificationPage1 from './Notification';
import { ListDetails } from './ListDetails'
import { Shortlisted } from './Shortlisted';
import { RoomDetails } from '../course/RoomDetails';
import { BookingSuccess } from './BookingSuccess';
import { ContactUs } from './ContactUs';
import { TermsAndConditions } from './TermsAndConditions';
import { LoanOptions } from './LoanOptions';
import { OurServices } from './OurServices';
import { HelpCenter } from './HelpCenter';
// import { RoomDetails } from './RoomDetails';
// import { Shortlisted } from './Shortlisted';
// import { PayRent } from './PayRent';

export const screens = {
  Home,
  SignIn,
  Search,
  SignUp,
  Filter,
  Profile,
  MyWallet,
  Checkout,
  MyCoupons,
  MyCourses,
  MyWishlist,
  Onboarding,
  AddANewCard,
  ProfileEdit,
  NewPassword,
  CategoryGrid,
  Dashboard,
  LeaveAReview,
  CategoryList,
  CourseDetails,
  PaymentFailed,
  PrivacyPolicy,
  ContactUs,
  PaymentSuccess,
  BookingSuccess,
  ForgotPassword,
  HelpAndSupport,
  CourseCompleted,
  ConfirmationCode,
  ChoosePaymentMethod,
  SignUpAccountCreated,
  VerifyYourPhoneNumber,
  ForgotPasswordSentEmail,
  CourseCompletedCertificate,
  AminitiesList,
  Onboarding0,
  Onboarding1,
  Onboarding2,
  Onboarding3,
  Onboarding4,
  Onboarding5,
  Onboarding6,
  Onboarding7,
  NotificationPage1,
  ListDetails,
  Shortlisted,
  RoomDetails,
  TermsAndConditions,
  LoanOptions,
  OurServices,
  HelpCenter
};
